import React from "react";
import RfxResponseComp from "newui/features/Rfx/Submission/components/RfxSubmissionStatusPill/RfxResponseComp";
import { TableCell, TableRow } from "components/RFQ/Table";
import tw, { styled } from "twin.macro";
import { Avatar } from "components/RFQ/Avatar";
import { SubmissionDeadline } from "components/RFQ/SubmissionDeadline/SubmissionDeadline";
import RFQStatusComp from "components/RFQ/RFQStatusComp";
const RfqList = ({ data, navigatePreview, isLoading, isLoadingPagination }) => {
	const SkeletonCustom = styled.div(() => [
		tw`animate-pulse bg-gray-300 w-full h-6`,
	]);

	const SkeleteonRow = () => (
		<TableRow>
			<TableCell>
				<SkeletonCustom />
			</TableCell>
			<TableCell>
				<SkeletonCustom />
			</TableCell>
			<TableCell>
				<SkeletonCustom />
			</TableCell>
			<TableCell>
				<SkeletonCustom />
			</TableCell>
			<TableCell>
				<SkeletonCustom />
			</TableCell>
			<TableCell>
				<SkeletonCustom />
			</TableCell>
		</TableRow>
	);
	const tableHeader = [
		{
			name: "Project Name",
			width: "20%",
		},
		{
			name: "Response",
			width: "20%",
		},
		{
			name: "Client",
			width: "20%",
		},
		{
			name: "Submission Deadline",
			width: "20%",
		},
		{
			name: "RFx Status",
			width: "10%",
		},
		{
			action: "",
			width: "10%",
		},
	];

	return (
		<div className="overflow-x-auto rounded-md border border-[#EAECF0] bg-white shadow-lg">
			<table className="mb-3 mt-3 w-full table-auto rounded-md border-b border-solid border-[#EAECF0] bg-white">
				<thead style={{ height: "30px" }}>
					<tr className="border-b border-[#EAECF0]">
						{tableHeader.map((th, index) => {
							return (
								<th
									className="font-roboto text-[12px] font-medium text-tertiary-600"
									style={{ width: th.width, textAlign: "left" }}
								>
									<div
										style={{
											marginTop: "-10px",
											marginLeft: index === 0 ? "20px" : "0px",
										}}
									>
										{th?.name}
									</div>
								</th>
							);
						})}
					</tr>
				</thead>
				<tbody>
					{!isLoading && (
						<>
							{data.map((singelData, index) => {
								return (
									<tr
										key={index}
										className="border-b border-[#EAECF0] hover:bg-utility-blue-light-50/30"
										onClick={() =>
											navigatePreview(`${singelData?.rfq?.id}/documentation`)
										}
										style={{ cursor: "pointer" }}
									>
										<td className="px-4 py-2">
											<div className="flex items-center">
												<Avatar
													avatar={singelData?.rfq?.project?.logoPath}
													size="lg"
												/>
												<div className="ml-2">
													<h3 className="mt-3 line-clamp-1 overflow-hidden font-roboto text-[14px] font-semibold capitalize text-primary-900">
														{singelData?.rfq?.name}
													</h3>
													<div className="mb-4 font-roboto text-[14px] font-normal uppercase text-primary-500">
														{singelData?.rfq?.supplierList?.name}
													</div>
												</div>
											</div>
										</td>
										<td>
											<RfxResponseComp
												response={singelData?.status}
											></RfxResponseComp>
										</td>
										<td>
											<div className="font-roboto text-[14px] font-medium text-primary-500">
												{singelData?.rfq.client}
											</div>
										</td>
										<td>
											<div>
												<SubmissionDeadline
													className="font-roboto text-[14px] font-medium text-primary-500"
													deadlineDateTime={singelData?.rfq?.submissionDeadline}
													deadlineTimeZone={singelData?.rfq?.submissionTimezone}
													showTimeUnderneath={true}
													submissionStatus={singelData?.status}
												/>
											</div>
										</td>
										<td>
											<RFQStatusComp
												status={singelData?.rfq?.status}
												isRoundedFull={false}
											></RFQStatusComp>
										</td>
										<td></td>
									</tr>
								);
							})}
						</>
					)}
					{isLoadingPagination && (
						<>
							<SkeleteonRow />
							<SkeleteonRow />
							<SkeleteonRow />
						</>
					)}
				</tbody>
			</table>
		</div>
	);
};

export default RfqList;
